<template>
  <div class="user-list">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>用户管理</span>
          <el-button type="primary" @click="handleRefresh">刷新</el-button>
        </div>
      </template>
      
      <el-table :data="userList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="balance" label="余额">
          <template #default="{ row }">
            ¥{{ row.balance }}
          </template>
        </el-table-column>
        <el-table-column prop="points" label="积分" />
        <el-table-column prop="member_level_id" label="会员等级">
          <template #default="{ row }">
            <el-tag>{{ getMemberLevel(row.member_level_id) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" />
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        style="margin-top: 20px"
        @current-change="handlePageChange"
      />
    </el-card>
    
    <!-- 编辑对话框 -->
    <el-dialog v-model="dialogVisible" title="编辑用户" width="500px">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="昵称">
          <el-input v-model="editForm.nickname" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="editForm.phone" />
        </el-form-item>
        <el-form-item label="余额">
          <el-input-number v-model="editForm.balance" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="积分">
          <el-input-number v-model="editForm.points" :min="0" />
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="editForm.member_level_id">
            <el-option label="普通会员" :value="1" />
            <el-option label="银卡会员" :value="2" />
            <el-option label="金卡会员" :value="3" />
            <el-option label="钻石会员" :value="4" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'UserList',
  setup() {
    const userList = ref([])
    const loading = ref(false)
    const page = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const dialogVisible = ref(false)
    const editForm = ref({})
    
    const getMemberLevel = (level) => {
      const levels = { 1: '普通会员', 2: '银卡会员', 3: '金卡会员', 4: '钻石会员' }
      return levels[level] || '普通会员'
    }
    
    const fetchUsers = async () => {
      loading.value = true
      try {
        const res = await request.get('/api/admin/users', {
          params: { page: page.value, limit: pageSize.value }
        })
        // Handle both formats: {data: [...]} or {data: {list: [...], total}}
        if (Array.isArray(res.data)) {
          userList.value = res.data
          total.value = res.total || 0
        } else if (res.data && Array.isArray(res.data.list)) {
          userList.value = res.data.list
          total.value = res.data.total || 0
        } else {
          userList.value = []
          total.value = 0
        }
      } catch (error) {
        ElMessage.error('获取用户列表失败')
      } finally {
        loading.value = false
      }
    }
    
    const handleRefresh = () => {
      fetchUsers()
    }
    
    const handlePageChange = (val) => {
      page.value = val
      fetchUsers()
    }
    
    const handleEdit = (row) => {
      editForm.value = { ...row }
      dialogVisible.value = true
    }
    
    const handleSave = async () => {
      try {
        await request.put(`/api/admin/users/${editForm.value.id}`, editForm.value)
        ElMessage.success('保存成功')
        dialogVisible.value = false
        fetchUsers()
      } catch (error) {
        ElMessage.error('保存失败')
      }
    }
    
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm('确认删除该用户？', '提示', { type: 'warning' })
        await request.delete(`/api/admin/users/${row.id}`)
        ElMessage.success('删除成功')
        fetchUsers()
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败')
        }
      }
    }
    
    onMounted(() => {
      fetchUsers()
    })
    
    return {
      userList,
      loading,
      page,
      pageSize,
      total,
      dialogVisible,
      editForm,
      getMemberLevel,
      handleRefresh,
      handlePageChange,
      handleEdit,
      handleSave,
      handleDelete
    }
  }
}
</script>

<style scoped>
.user-list {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.card-header span {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}
</style>
